import { useCallback, useEffect, useMemo } from "react";
import { useCreateSettingMutation, useGetSettingsQuery } from "../../../api/plamo-api";
import PlamoApiWithSaveNotifications from "../util/with-save-notification";

const {
  useUpdateSettingWithSaveNotificationMutation
} = PlamoApiWithSaveNotifications

export const useSetting = (ident: string, scope: string, initialValue: any) => {
  const { data } = useGetSettingsQuery({ f: JSON.stringify({ ident: { c: "EQ", v: ident }, scope: { c: "EQ", v: scope } }) }) as any;
  const [createSetting] = useCreateSettingMutation();
  const [updateSetting] = useUpdateSettingWithSaveNotificationMutation();
  const setting = useMemo(() => (data?.items || [])[0], [data]);
  const settingValue = useMemo(() => setting ? JSON.parse(setting.value) : null, [setting]);

  const initialValueString = useMemo(() => JSON.stringify(initialValue), [initialValue]);

  useEffect(() => {
    if(data?.items?.length === 0) {
      createSetting({
        ident,
        scope,
        value: initialValueString
      })
    }
  }, [data?.items, createSetting, ident, initialValueString, scope])

  const updateSettingValue = useCallback(newValue => {
    const newSetting = {
      ...setting,
      value: JSON.stringify(newValue),
    }
    updateSetting(newSetting);
  }, [setting, updateSetting])

  return [settingValue, updateSettingValue];
}